import React, { Component } from "react"
import { graphql } from "gatsby"
import { Helmet } from "react-helmet"
// import ImageObserver from '../layout/observer-image-target'

import Header from "../layout/header"
import Footer from "../layout/footer"
// import * as Scroll from "react-scroll"

export default class WhitePapers extends Component {
  componentDidMount() {
    // const { markdownRemark } = this.props.data
    // const post = markdownRemark
    // window.analytics.page(post.frontmatter.title,'| Limeproxies');
    window.analytics.page("Whitepapers Post | Limeproxies")
  }

  render() {
    const data = this.props.data
    const whitepaper = data.whitepapers.edges

    // const customStyleObject = {
    //   marginTop: "100px",
    // }

    // let LinkScroll = Scroll.Link
    // let Element = Scroll.Element

    return (
      <main className="inner-whitepapers">
        <Helmet>
          <meta charSet="utf-8" />
          <meta
            name="title"
            content="Best VPN & Proxie Servers E-Books | Limeproxies"
          />
          <meta
            name="description"
            content="Check our collection of the best VPN & Proxie servers books will keep you up to date and ahead of the competition. It's all 100% free. Start reading now!"
          />
          <meta name="keywords" content="customer proxy" />
          <title>White Papers | Limeproxies</title>
        </Helmet>
        <Header />

        <section className="whitepapers-banner">
          <div className="ui container">
            <div className="banner-holder">
              {whitepaper.map((item, i) => {
                if (typeof window !== `undefined`) {
                  if (
                    window.location.pathname ===
                    "/whitepapers" + item.node.frontmatter.path
                  ) {
                    return (
                      <div className="banner-text" key={i}>
                        <h1 className="text-h1">
                          {item.node.frontmatter.whitepaperTitle}
                        </h1>
                        <br />
                        <h3 className="text-h3">
                          {item.node.frontmatter.whitepaperDescription}
                        </h3>
                      </div>
                    )
                  }
                }
              })}

              <div className="whitepapers-form">
                <div className="form-content">
                  <p className="text-p">
                    Complete the form to get the white paper:
                  </p>
                  <form className="form-holder-main">
                    <div>
                      <input
                        type="text"
                        name="firstname"
                        placeholder="First Name"
                        className="form-fields"
                      />
                    </div>
                    <div>
                      <input
                        type="text"
                        name="lastname"
                        placeholder="Last Name"
                        className="form-fields"
                      />
                    </div>
                    <div>
                      <input
                        type="email"
                        name="email"
                        placeholder="Work Email"
                        className="form-fields"
                      />
                    </div>
                    <div>
                      <input
                        type="text"
                        name="companyname"
                        placeholder="Company Name"
                        className="form-fields"
                      />
                    </div>
                    <div>
                      <input
                        type="text"
                        name="jobtitle"
                        placeholder="Job Title"
                        className="form-fields"
                      />
                    </div>
                    <div className="form-button">
                      <input
                        type="submit"
                        value="Download now"
                        className="btn-lg-red"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="whitepapers-body">
          <div className="ui container">
            <div className="body-holder">
              {whitepaper.map((item, i) => {
                if (typeof window !== `undefined`) {
                  if (
                    window.location.pathname ===
                    "/whitepapers" + item.node.frontmatter.path
                  ) {
                    return <h3>{item.node.frontmatter.whitepaperContent}</h3>
                  }
                }
              })}
            </div>
            <h3>With this Limeproxies white paper, you will learn about:</h3>
            <div className="whitepapers-description">
              {whitepaper.map((item, i) => {
                if (typeof window !== `undefined`) {
                  if (
                    window.location.pathname ===
                    "/whitepapers" + item.node.frontmatter.path
                  ) {
                    return (
                      <div className="whitepapers-desc-holder" key={i}>
                        <ul>
                          {item.node.frontmatter.whitepaperFeature.map(
                            (item, i) => {
                              return (
                                <li key={i}>
                                  <span className="text-span">
                                    {
                                      item.whitepaperFeatureContent
                                        .whitepaperFeatureTitle
                                    }
                                  </span>
                                </li>
                              )
                            }
                          )}
                        </ul>
                      </div>
                    )
                  }
                }
              })}
            </div>
          </div>
        </section>
        <Footer />
      </main>
    )
  }
}

export const pageQuery = graphql`
  query WhitePapersInner {
    whitepapers: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/whitepapers/" } }
      sort: { order: ASC, fields: [frontmatter___title] }
    ) {
      edges {
        node {
          html
          frontmatter {
            path
            whitepaperTitle
            whitepaperDescription
            whitepaperContent
            whitepaperFeature {
              whitepaperFeatureContent {
                whitepaperFeatureTitle
              }
            }
          }
        }
      }
    }
  }
`
